import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Signal03 = function Signal03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10.5858 13.4142c-.781-.781-.781-2.0474 0-2.8284s2.0474-.781 2.8284 0c.7811.781.7811 2.0474 0 2.8284m-5.6568 2.8284c-2.3432-2.3431-2.3432-6.1421 0-8.4852s6.1421-2.3432 8.4852 0 2.3432 6.1421 0 8.4852M4.9289 19.0711c-3.9052-3.9053-3.9052-10.237 0-14.1422 3.9053-3.9052 10.2369-3.9052 14.1422 0 3.9052 3.9053 3.9052 10.2369 0 14.1422"
    })
  }));
};
export default Signal03;